import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Shield, Check } from 'lucide-react';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const testMode = new URLSearchParams(window.location.search).get('cookietest') === 'true';
    if (!localStorage.getItem('cookieConsent') || testMode) {
      const t = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = (value) => {
    localStorage.setItem('cookieConsent', value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 60, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[60]"
          data-testid="cookie-banner"
        >
          <div className="lux-card-dark p-6 text-white shadow-2xl shadow-black/60 relative">
            <button onClick={() => setVisible(false)} className="absolute top-4 right-4 text-slate-500 hover:text-white transition-colors" aria-label="Schließen" data-testid="cookie-close">
              <X className="w-4 h-4" />
            </button>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center">
                <Shield className="w-5 h-5 text-amber-400" />
              </div>
              <h3 className="font-display font-bold text-lg">Cookies & Datenschutz</h3>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Wir nutzen Cookies, um die Website zu verbessern. Notwendige Cookies sind für den Betrieb erforderlich, alle weiteren nur mit deiner Zustimmung.{' '}
              <a href="/impressum.html" className="text-amber-300 hover:text-amber-200 underline underline-offset-2">Datenschutzerklärung</a>
            </p>
            <div className="mt-5 flex flex-col sm:flex-row gap-3">
              <button onClick={() => accept('all')} className="btn-gold flex-1 py-2.5 text-sm" data-testid="cookie-accept-all">
                <Check className="w-4 h-4" /> Alle akzeptieren
              </button>
              <button onClick={() => accept('necessary')} className="btn-ghost-dark flex-1 py-2.5 text-sm" data-testid="cookie-necessary-only">
                Nur notwendige
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
